<template>
    <v-card outlined v-if="order">
        <v-toolbar flat color="grey lighten-4">
            <v-row>
                <v-col cols="6" md="4">
                    <v-card-text class="h6 font-weight-bold text-uppercase">
                        {{ sellerTitle }}
                    </v-card-text>
                </v-col>
                <v-col cols="6" md="4">
                    <v-card-text>
                        {{ summaryPrice ? `${summaryPrice}
                        ${currency.cyrName.toLowerCase()}` : '----' }}
                    </v-card-text>
                </v-col>
            </v-row>
        </v-toolbar>

        <v-divider></v-divider>
        <v-card-text class="pa-0">
            <v-row class="pa-0">
                <v-col cols="12" v-for="product in order.data" :key="product.id" class="d-flex justify-center pa-0">
                    <product-card
                        :product="product"
                        @order-change="orderChange"
                        @delete-product="deleteProduct"
                    ></product-card>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-text>
            <div class="d-flex flex-column align-center flex-md-row justify-md-space-between">
                <div class="d-flex flex-column body-1">
                    <div class="d-flex">
                        <strong class="mr-1">{{ $t('total') }} {{ $t('withoutDelivery').toLowerCase() }}:</strong>
                        <div v-if="orderTotalPrice" :class="['mr-1', priceCss]">
                            {{ priceString(orderTotalPrice) }} {{ currency.cyrName.toLowerCase() }}
                        </div>
                        <div v-if="!orderTotalPrice" class="mr-1">
                            ----
                        </div>
                    </div>
                    <div class="d-flex align-center pb-4 pb-md-0">
                        <div v-if="hasDiscount" class="mr-2 title font-weight-bold">
                            {{ priceString(orderCalculatedPrice) }} {{ currency.cyrName.toLowerCase() }}
                        </div>
                        <div v-if="hasDiscount" class="teal--text font-weight-bold mr-2">
                            ({{ $t('discount') }} {{ orderTotalDiscount.toFixed(1) }} %)
                        </div>
                    </div>
                </div>
                <div class="d-flex align-center">
                    <div class="mx-2 mt-n1" v-if="hasPolicies">
                        <policies-dialog
                            :seller-id="order.seller.id"
                            :seller-name="sellerTitle"
                        ></policies-dialog>
                    </div>
                    <!--Mobile and Ipad-->
                    <v-btn
                        depressed
                        class="main--yellow white--text hidden-xs-only hidden-md-and-up"
                        @click="goToCheckout"
                        x-small
                    >
                        {{ $t('prepare') }}
                    </v-btn>
                    <!--Ipad Pro-->
                    <v-btn
                        depressed
                        class="main--yellow white--text hidden-sm-only hidden-lg-and-up"
                        @click="goToCheckout"
                        small
                    >
                        {{ $t('prepare') }}
                    </v-btn>
                    <!--Desktop-->
                    <v-btn
                        depressed
                        class="main--yellow white--text hidden-md-and-down"
                        @click="goToCheckout"
                    >
                        {{ $t('prepare') }}
                    </v-btn>
                </div>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
    import DeliveryDate from './DeliveryDate';
    import PaymentMethod from './PaymentMethod';
    import PoliciesDialog from './PoliciesDialog';
    import ProductCard from './ProductCard';
    import Auth from "../../../../app-front/mixins/Auth";
    import OrderCalculator from '../../../../app-front/mixins/OrderCalculator';
    import numberFormat from "../../../../utils/numberFormat";

    export default {
        name: "OrderCard",
        props: ['order'],
        mixins: [
            Auth,
            OrderCalculator,

        ],
        components: {
            PaymentMethod,
            PoliciesDialog,
            DeliveryDate,
            ProductCard
        },
        data() {
            return {
                paymentWay: null,
                creditPolicy: null,
                date: null,
            }
        },
        computed: {
            myBasketItems(){
                return this.isUserLoggedIn ? this.basketItems : this.$store.getters.noLoginBasket.map(item => {
                    return {
                        productId: item.id,
                        quantity: item.quantity
                    }
                });
            },
            currency() {
                return this.$store.state.currency[0];
            },
            hasDiscount() {
                return !!this.orderCalculation.policies.discounts.length;
            },
            hasPolicies() {
                let hasPolicies = false;

                if (!this.order.policies) return hasPolicies;

                if (this.order.policies.amountPolicy && this.order.policies.amountPolicy.length) hasPolicies = true;
                if (this.order.policies.datePolicy && this.order.policies.datePolicy.length) hasPolicies = true;
                if (this.order.policies.paymentPolicy && this.order.policies.paymentPolicy.credits && this.order.policies.paymentPolicy.credits.length) hasPolicies = true;
                if (this.order.policies.paymentPolicy && this.order.policies.paymentPolicy.prepayment && this.order.policies.paymentPolicy.prepayment.length) hasPolicies = true;

                return hasPolicies;
            },
            orderProducts() {
                const inProcess = this.inProcessProducts || [];
                const sellerOrder = inProcess.find(item => item.sellerID === this.order.seller.id);

                return sellerOrder ? sellerOrder.products : [];
            },
            sellerTitle() {
                if (!this.order.seller) return '';

                return this.order.seller.companyName || `${this.order.seller.lastName} ${this.order.seller.firstName}`
            },
            summaryPrice() {
                return this.orderCalculatedPrice ? this.priceString(this.orderCalculatedPrice) : null;
            },
            priceCss() {
                return this.hasDiscount ? 'text-decoration-line-through' : '';
            },
        },
        methods: {
            orderChange(data) {
                if (!data.price) {
                    this.$store.commit('orderInProcessClearProduct', data.id);
                } else {
                    const emitData = {
                        product: data,
                        policies: this.order.policies,
                        date: this.date,
                        paymentWay: this.paymentWay,
                        sellerID: this.order.seller.id
                    };

                    this.updateProductsInProcess(emitData);
                    const item = this.myBasketItems.find(item => item.productId === data.id);
                    if(item.quantity !== data.quantity && data.quantity >= 0) {
                        this.$emit('update-basket', {id: data.id, quantity: data.quantity});
                    }                }
                this.calculatePrice();
            },
            orderDateChange(dateValue) {
                this.date = dateValue;
                this.setOrderDate({sellerID: this.order.seller.id, date: this.date});
                this.calculatePrice();
            },
            orderPaymentChange(data) {
                this.paymentWay = data.value;
                this.creditPolicy = data.creditPolicy;
                this.setOrderPayment({
                    sellerID: this.order.seller.id,
                    creditPolicy: this.creditPolicy,
                    paymentWay: this.paymentWay
                });

                this.calculatePrice();
            },
            deleteProduct(id) {
                const data = {
                    productID: id,
                    sellerID: this.order.seller.id
                };
                this.$emit('delete-product', data);
                this.clearProductInProcess(data.productID);
                if(this.isUserLoggedIn) {
                    this.clearBasketItem(id);
                } else {
                    this.clearNoLoginBasketItem(id)
                }
            },
            clearBasketItem(id) {
                const items = this.basketItems.filter(item => item.productId !== id);
                this.$store.commit('setBasket', items);

                if(!items.length) this.setOrderProducts([]);
            },
            clearNoLoginBasketItem(id) {
                const items = this.$store.getters.noLoginBasket.filter(item => item.productId !== id);
                this.$store.commit('setNoLoginBasket', items);

                if(!items.length) this.setOrderProducts([]);
            },
            goToCheckout() {
                this.$router.push({name: 'checkout', query: {
                        sellerID: this.order.seller.id
                    }
                });
            },
            priceString(price) {
                return price ? numberFormat(price, 2, '.', ' ') : false;
            },
        },
        watch: {
            orderProducts: {
                handler() {
                    this.calculatePrice();
                },
                deep: true
            },
            date() {
                this.updateOrderDate({sellerID: this.order.seller.id, value: this.date});
            },
            paymentWay() {
                this.updateOrderCreditPolicy({sellerID: this.order.seller.id, value: this.creditPolicy});
                this.updateOrderPaymentWay({sellerID: this.order.seller.id, value: this.paymentWay});
            },
        }
    }
</script>

<style scoped>
    .text-decoration-line-through {
        text-decoration: line-through !important;;
    }
</style>
